import { FC } from 'react'
import { css } from '@emotion/react'
import { typography } from '@lifedot/styles/typography'
import { AnswerLink } from '@/components/Dialogue/AnswerLink'
import { dialogueAnswers } from '@lifedot/constants/dialogue'
import { EventTracker } from '@lifedot/tracking'
import { mq } from '@lifedot/styles/mediaQuery'
import { QuestionBase } from '@/components/Dialogue'

const styles = {
  answer: css({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: '120px 80px',
    gap: 16,
    marginTop: 12,
    [mq('sp')]: {
      gridTemplateRows: '100px 60px',
      gap: 12
    }
  }),
  other: css({
    gridColumn: '1 / 3'
  })
}

export const QuestionSectionType: FC<QuestionBase> = ({ handleAnswer }) => {
  return (
    <>
      <p css={typography.headingXS}>お墓は代々継いでいきたいですか？</p>
      <div css={styles.answer}>
        <EventTracker action="click" label="dialogue_sectionType_はい" clone>
          <AnswerLink
            onClick={() => handleAnswer(dialogueAnswers.sectionType.yes)}
          >
            はい
          </AnswerLink>
        </EventTracker>
        <EventTracker action="click" label="dialogue_sectionType_いいえ" clone>
          <AnswerLink
            onClick={() => handleAnswer(dialogueAnswers.sectionType.no)}
          >
            いいえ
          </AnswerLink>
        </EventTracker>
        <div css={styles.other}>
          <EventTracker
            action="click"
            label="dialogue_sectionType_わからない"
            clone
          >
            <AnswerLink
              onClick={() => handleAnswer(dialogueAnswers.sectionType.unknown)}
            >
              わからない
            </AnswerLink>
          </EventTracker>
        </div>
      </div>
    </>
  )
}
